export class URLParser {
  constructor(url) {
    const modifiedURL = url.toLowerCase().replace(/.*:\/\//, 'http://');
    const urlObject = new URL(modifiedURL);
    this.hostname = urlObject.hostname;
    this.pathname = urlObject.pathname.slice(1);
    this.searchParams = urlObject.searchParams;
  }
}
